export const isBranch = (fullBranchName?: string): boolean => {
  return !!fullBranchName?.startsWith("refs/heads");
};

const getPullRequestNumberAsString = (fullBranchName?: string): string => {
  return fullBranchName?.split("/").slice(-2)[0] || "";
};

export const getPullRequestNumber = (
  fullBranchName?: string
): string | undefined => {
  // full pull request name is in the format "refs/pull/#xx/merge"
  return getPullRequestNumberAsString(fullBranchName);
};

export const isPullRequest = (ref?: string): boolean => {
  return !isNaN(parseFloat(getPullRequestNumberAsString(ref)));
};

export const getBranchName = (fullBranchName?: string): string | undefined => {
  // full branch name starts with "refs/heads/origin/", so trim that for the url
  if (fullBranchName?.startsWith("refs/heads/origin/"))
    return fullBranchName.replace("refs/heads/origin/", "");
  // full branch name starts with "refs/heads/", so trim that for the url
  else if (fullBranchName?.startsWith("refs/heads/"))
    return fullBranchName.replace("refs/heads/", "");
  return fullBranchName;
};
